import React, { Component } from 'react'
import { Box, Main, Text } from 'grommet'
import axios from 'axios'
import { PageHeader } from './Common'
import { core } from '../api/retail'

class Logs extends Component {
  state = { logs: [] }
  componentDidMount() {
    this.getLogs()
  }

  getLogs = () => {
    const response = core
      .getTable('CustomDebugLog')
      .then((result) => this.setState({ logs: result.data.data }))
  }
  render() {
    return (
      <Box fill>
        <PageHeader heading={'Logs'} />
        <Main pad="medium" flex="shrink" gap={'small'}>
          {this.state.logs.length === 0 && (
            <Text textAlign="center" weight="bold" color={'dark-6'}>
              No logs yet..
            </Text>
          )}
          {this.state.logs.map((log) => (
            <Box
              flex={false}
              fill={'horizontal'}
              pad={'medium'}
              gap={'medium'}
              direction={'row'}
              key={log.id}
              round={'xsmall'}
              elevation={'small'}
              justify={'start'}
              background={'white'}
            >
              <Box flex={false} width={'small'}>
                <Text weight={'bold'} truncate>
                  {log.target}
                </Text>
              </Box>
              <Box justify="start" fill={'horizontal'}>
                <Text truncate color={'dark-6'}>
                  {log.error}
                </Text>
              </Box>
              <Box align="end" flex={false} width={'medium'}>
                <Text color={'dark-6'}>{log.creation_time}</Text>
              </Box>
            </Box>
          ))}
        </Main>
      </Box>
    )
  }
}
export default Logs
